const UpdateFormFields = ({ texts, handleChange }) => {
    return (
        <>
            <label>
                Email
            </label>
            
            <input
                type="text"
                name="email"
                value={texts.email}
                onChange={handleChange}
            />

            <label>
                Password
            </label>

            <input
                type="text"
                name="password"
                value={texts.password}
                onChange={handleChange}
                placeholder="Leave blank to keep current password"
            />

            <label>
                Name
            </label>

            <input
                type="text"
                name="name"
                value={texts.name}
                onChange={handleChange}
            />

            <label>
                Country / City
            </label>

            <input
                type="text"
                name="city"
                value={texts.city}
                onChange={handleChange}
            />

            <label>
                Website
            </label>

            <input
                type="text"
                name="website"
                value={texts.website}
                onChange={handleChange}
            />
        </>
    );
};

export default UpdateFormFields;